<div class="product-page">
  <div class="page-header">
    <app-back-button
      parentRoute="/admin/process-management/satellite-products"
      [useHistoryBack]="true"
      [title]="pageHeading().title"
      [subtitle]="pageHeading().subtitle"
    ></app-back-button>
    <div class="header-actions">
      @if (analysis(); as product) {
        <a class="gis-link" routerLink="/admin/process-management/gis"
          [queryParams]="{ source: 'field-segmentation', satelliteProductId: product.id }">
          <i class="pi pi-map-marker"></i> {{ 'ORCH_GIS_OPEN' | translate }}
        </a>
      }
      <app-secondary-button
        title="Refresh data"
        icon="refresh"
        size="small"
        [disable]="loading()"
        [loading]="loading()"
        (action)="reload()"
      ></app-secondary-button>
    </div>
  </div>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  }

  @if (analysis(); as product) {
    <header class="product-heading">
      <div>
        <h2>{{ product.externalProductId }}</h2>
        <p class="section-hint">{{ 'Satellite product analysis' | translate }}</p>
        <app-copyable-identifier [value]="product.id || ''"></app-copyable-identifier>
      </div>
    </header>

    <section class="product-section">
      <h3>{{ 'Catalogue stage' | translate }}</h3>
      <div class="snapshot-grid">
        @for (row of snapshotRows(); track row.label) {
          <div>
            <span>{{ row.label | translate }}</span>
            @if (row.translateValue) {
              <strong>{{ row.value | translate }}</strong>
            } @else {
              <strong>{{ row.value }}</strong>
            }
          </div>
        }
        <div>
          <span>{{ 'Acquisition date' | translate }}</span>
          <strong>
            {{ product.originDate ? (product.originDate | dateFormatLang:translate.currentLang) : '—' }}
          </strong>
        </div>
        <div>
          <span>{{ 'Discovered at' | translate }}</span>
          <strong>{{ product.discoveredAt | dateFormatLang:translate.currentLang }}</strong>
        </div>
      </div>
    </section>

    <section class="product-section orch-table-panel">
      <app-orchestration-table-heading heading="Assignments for this product" queryParam="steps" [(query)]="stepSearch">
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="stepColumns()"
        [data]="visibleSteps()"
        [config]="stepTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>

    <section class="product-section orch-table-panel">
      <app-orchestration-table-heading heading="Processing steps" queryParam="processing" [(query)]="processingSearch">
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="processingColumns()"
        [data]="visibleProcessingSteps()"
        [config]="processingTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>

    <section class="product-section orch-table-panel">
      <app-orchestration-table-heading heading="Artifacts" queryParam="artifacts" [(query)]="artifactSearch">
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="artifactColumns()"
        [data]="visibleArtifacts()"
        [config]="artifactTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>

    <section class="product-section orch-table-panel">
      <app-orchestration-table-heading heading="Trigger executions for this product" queryParam="executions" [(query)]="executionSearch">
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="executionColumns()"
        [data]="visibleExecutions()"
        [config]="executionTableConfig"
        [loading]="loading()"
      ></app-data-table>
    </section>
  } @else if (loading()) {
    <app-loading [loading]="true"></app-loading>
  }
</div>

<ng-template #stepKindTemplate let-row>
  {{ row.kind | translate }}
</ng-template>

<ng-template #stepProcessTemplate let-row>
  <app-copyable-identifier [value]="row.processDefinitionKey || ''" [link]="row.processUrl"></app-copyable-identifier>
</ng-template>

<ng-template #stepAssignmentTemplate let-row>
  <app-copyable-identifier [value]="row.assignmentId || ''" [link]="row.assignmentUrl"></app-copyable-identifier>
</ng-template>

<ng-template #stepStateTemplate let-row>
  <p-tag [value]="row.assignmentState | translate" [severity]="row.stateSeverity"></p-tag>
</ng-template>

<ng-template #executionStateTemplate let-row>
  <p-tag [value]="row.state | translate" [severity]="row.stateSeverity"></p-tag>
</ng-template>

<ng-template #executionPublisherTemplate let-row>
  <app-copyable-identifier [value]="row.sourceAssignmentId || ''" [link]="row.sourceAssignmentUrl"></app-copyable-identifier>
</ng-template>

<ng-template #processingStepTemplate let-row>
  {{ row.stepTypeLabelKey | translate }}
</ng-template>

<ng-template #artifactRoleTemplate let-row>
  {{ row.roleLabelKey | translate }}
</ng-template>

<ng-template #artifactIdTemplate let-row>
  <app-copyable-identifier [value]="row.id || ''"></app-copyable-identifier>
</ng-template>

<ng-template #executionStartedTemplate let-row>
  <app-copyable-identifier [value]="row.targetAssignmentId || ''" [link]="row.targetAssignmentUrl"></app-copyable-identifier>
</ng-template>
